import styled from 'styled-components';
import { colors } from 'spw-theme';
import { ColorBubble } from 'spw-components/dialogs/styles';

export const CategoryColorBubble = styled.div`
  && {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: 38px;
    border-radius: 50%;

    &.selected {
      outline: solid 1px ${colors.black};
    }
  }
`;

export const SmallCategoryColorBubble = styled(ColorBubble)`
  width: 32px;
  height: 32px;
  border-radius: 50%;
`;
